import Vue from "vue";
import App from "./App.vue";
import "./style/index.scss";
import router from "@/router";
import i18n from "./i18n";

Vue.config.productionTip = false;
// swiper bundle styles
import "swiper/css/bundle";

// swiper core styles
import "swiper/css";

// modules styles
import "swiper/css/navigation";
import "swiper/css/pagination";

const mixin = {
  methods: {
    openUrl(url) {
      const pre = this.$route.params.lang === "cn" ? "/cn" : "";
      window.open(`${pre}${url}`, "__blank");
    },
  },
};
Vue.mixin(mixin);
new Vue({
  render: (h) => h(App),
  i18n,
  router,
}).$mount("#app");
